export default "__VITE_ASSET__vOIh90nb__"